<template>
    <div class="compare" id="compare">
        <h1 :data-title="'(' + count + ')'">Meine Vergleichsliste</h1>

        <div class="d-all" v-show="count > 1 && loaded" style="padding-top:20px">
            <p @click="deleteAll"><i class="fa fa-trash"></i> Vergleich löschen</p>
        </div>

        <div class="compare-container" id="compareContainer" v-show="dataObjects && loaded && count" :class="{'sm' : count <= 3}" :data-length="count">
            <div class="legend">
                <ul>
                    <li>
                        <a href="#" class="img"><span><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAByAQMAAADKwgXPAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAABFJREFUOMtjGAWjYBSMAjoCAAR0AAHEcq2UAAAAAElFTkSuQmCC" alt=""></span></a>
                        <span class="title"><span>Bezeichnung</span></span>
                        <span class="price"><span>Preis</span></span>
                        <span class="feedback"><span>Bewertung</span></span>
                        <span class="area"><span>Grundfläche</span></span>
                        <span class="uroom"><span>Umbauter Raum</span></span>
                        <span class="thick"><span>Wandstärke</span></span>
                        <span class="roof"><span>Dachform</span></span>
                        <span class="floor"><span>Fußboden inkl.</span></span>
                        <span class="room"><span>Anzahl Räume</span></span>
                        <span class="length"><span>Länge</span></span>
                        <span class="width"><span>Breite</span></span>
                        <span class="height"><span>Höhe</span></span>
                        <span class="avail"><span>Lieferzeit</span></span>
                        <span class="c2a-btns"><span></span></span>
                    </li>
                </ul>
            </div>
            <div class="scroller" id="scroller">
                <ul class="compare-list" id="compareList">
                    <li v-for="item in dataObjects" :id="'c' + item.id">
                        <a class="img" :href="item.data | itemURL">
                            <span data-toggle="tooltip" data-placement="top" v-tooltip title="zum Artikel">
                                <img v-if="item.data.images.variation.length" class="lazyload" :data-src="item.data.images.variation[0].urlMiddle" alt="">
                                <img v-else class="lazyload" :data-src="item.data.images.all[0].urlMiddle" alt="">
                            </span>
                            <span @click="removeItem('c' + item.id)" class="img-remove" data-toggle="tooltip" data-placement="top" v-tooltip title="vom Vergleich entfernen"></span>
                        </a>
                        <span class="title"><span>{{ item.data.texts.name1 }}</span></span>
                        <span class="price">
                            <span>
                                <del v-if="item.data.prices.specialOffer">
                                    {{ item.data.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                                </del>
                                <del v-else-if="item.data.prices.rrp && item.data.prices.rrp.unitPrice.value > 0 && item.data.prices.rrp.unitPrice.value > item.data.prices.default.unitPrice.value" class="rrp">
                                    {{ item.data.prices.rrp.unitPrice.formatted }}
                                </del>
                                <i v-if="item.data.prices.specialOffer && (item.data.prices.specialOffer.price.value < item.data.prices.default.unitPrice.value)">{{ item.data.prices.specialOffer.price.formatted }}</i>
                                <i v-else>{{ item.data.prices.default.unitPrice.formatted }}</i>
                            </span>
                        </span>
                        <span class="feedback">
                            <span v-if="item.data.item.feedbackCount">
                                <span class="rating">
                                    <span class="blank"></span>
                                    <span class="rate" :style="'width:' + (item.data.item.feedbackDecimal * 20) + '%'"></span>
                                </span>
                                <span>({{ item.data.item.feedbackCount }})</span>
                            </span>
                            <span v-else>
                                <span class="rating no">
                                    <span class="blank"></span>
                                    <span class="rate" style="width:0"></span>
                                </span>
                                <span>(0)</span>
                            </span>
                        </span>
                        <template v-for="prop in item.data.variationProperties">
                            <template v-for="prop in prop.properties">
                                <span class="area" v-if="prop.id == 54 && prop.groupId == 2">
                                    <span>{{ prop.values.value }}</span>
                                </span>
                            </template>
                        </template>
                        <span class="area">
                            <span><span class="fa fa-minus"></span></span>
                        </span>
                        <template v-for="prop in item.data.variationProperties">
                            <template v-for="prop in prop.properties">
                                <span class="uroom" v-if="prop.id == 57 && prop.groupId == 2">
                                    <span>{{ prop.values.value }}</span>
                                </span>
                            </template>
                        </template>
                        <span class="uroom">
                            <span><span class="fa fa-minus"></span></span>
                        </span>
                        <template v-for="prop in item.data.variationProperties">
                            <template v-for="prop in prop.properties">
                                <span class="thick" v-if="prop.id == 8 && prop.groupId == 2">
                                    <span>{{ prop.values.value }}</span>
                                </span>
                            </template>
                        </template>
                        <template v-for="prop in item.data.variationProperties">
                            <template v-for="prop in prop.properties">
                                <span class="roof" v-if="prop.id == 5 && prop.groupId == 2">
                                    <span>{{ prop.values.value }}</span>
                                </span>
                            </template>
                        </template>
                        <template v-for="prop in item.data.variationProperties">
                            <template v-for="prop in prop.properties">
                                <span class="floor" v-if="prop.id == 6 && prop.groupId == 2">
                                    <span :class="{'yes' : prop.values.value == 'ja'}">{{ prop.values.value }} &nbsp;</span>
                                </span>
                            </template>
                        </template>
                        <template v-for="prop in item.data.variationProperties">
                            <template v-for="prop in prop.properties">
                                <span class="room" v-if="prop.id == 7 && prop.groupId == 2">
                                    <span v-if="prop.values.value.charAt(0) == 1 || prop.values.value.charAt(0) == 2">{{ prop.values.value.charAt(0) }}</span>
                                    <span v-else>{{ prop.values.value }}</span>
                                </span>
                            </template>
                        </template>
                        <span class="length">
                            <template v-for="prop in item.data.variationProperties">
                                <template v-for="prop in prop.properties">
                                    <template v-if="prop.id == 12 && prop.groupId == 2">
                                        <span>{{ prop.values.value }}</span>
                                    </template>
                                </template>
                            </template>
                        </span>
                        <span class="width">
                            <template v-for="prop in item.data.variationProperties">
                                <template v-for="prop in prop.properties">
                                    <template v-if="prop.id == 11 && prop.groupId == 2">
                                        <span>{{ prop.values.value }}</span>
                                    </template>
                                </template>
                            </template>
                        </span>
                        <span class="height">
                            <template v-for="prop in item.data.variationProperties">
                                <template v-for="prop in prop.properties">
                                    <template v-if="prop.id == 47 && prop.groupId == 2">
                                        <span>{{ prop.values.value.replace(' cm','cm') }}</span>
                                    </template>
                                    <template v-if="prop.id == 48 && prop.groupId == 2">
                                        <span>{{ prop.values.value.replace(' cm','cm') }}</span>
                                    </template>
                                    <template v-if="prop.id == 49 && prop.groupId == 2">
                                        <span>{{ prop.values.value.replace(' cm','cm') }}</span>
                                    </template>
                                </template>
                            </template>
                        </span>
                        <span class="avail">
                            <span v-if="item.data.variation.availability" :class="'av' + item.data.variation.availability.id">{{ item.data.variation.availability.names.name.replace('Lieferzeit ', '') }}</span>
                            <span v-else><span class="fa fa-minus"></span></span>
                        </span>
                        <span class="c2a-btns">
                            <span>
                                <a :href="item.data | itemURL">zum Artikel</a>
                                <span @click="removeItem('c' + item.id)" data-toggle="tooltip" data-placement="top" v-tooltip title="vom Vergleich entfernen">Entfernen</span>
                            </span>
                        </span>
                    </li>
                </ul>
            </div>
            <button id="slideRight" class="deactivated" @click="scrollRight"><i class="fa fa-angle-left"></i></button>
            <button id="slideLeft" @click="scrollLeft"><i class="fa fa-angle-right"></i></button>
        </div>

        <div class="d-all" v-show="count > 1 && loaded" style="padding-top:20px">
            <p @click="deleteAll"><i class="fa fa-trash"></i> Vergleich löschen</p>
        </div>

        <div class="compare-container loading" id="loading" v-if="!loaded">
            <div class="legend">
                <ul>
                    <li>
                        <span class="img"><span></span></span>
                        <span class="title"><span>Bezeichnung</span></span>
                        <span class="price"><span>Preis</span></span>
                        <span class="feedback"><span>Bewertung</span></span>
                        <span class="area"><span>Grundfläche</span></span>
                        <span class="uroom"><span>Umbauter Raum</span></span>
                        <span class="thick"><span>Wandstärke</span></span>
                        <span class="roof"><span>Dachform</span></span>
                        <span class="floor"><span>Fußboden inkl.</span></span>
                        <span class="room"><span>Anzahl Räume</span></span>
                        <span class="length"><span>Länge</span></span>
                        <span class="width"><span>Breite</span></span>
                        <span class="height"><span>Höhe</span></span>
                        <span class="avail"><span>Lieferzeit</span></span>
                        <span class="c2a-btns"><span></span></span>
                    </li>
                </ul>
            </div>
            <div class="scroller">
                <ul class="compare-list">
                    <li>
                        <a href="#" class="img"><span><span></span></span></a>
                        <span class="title"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="price"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="feedback"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="area"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="uroom"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="thick"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="roof"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="floor"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="room"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="length"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="width"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="height"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="avail"><span><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp;</span></span>
                        <span class="c2a-btns"><span></span></span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="empty" v-if="count == 0 && loaded">
            Sie haben aktuell keine Artikel auf der Vergleichsliste
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                ids: [],
                dataObjects: false,
                loaded: false,
                count: 0
            }
        },
        afterCreated: function() {
            this.updateList();
        },
        mounted: function() {
            var self = this;

            if (localStorage.getItem('compareListItems') === null) {
                this.loaded = true;
            } else if (localStorage.getItem('compareListItems') && JSON.parse(localStorage.getItem('compareListItems')).length) {
                var dataObjects = JSON.parse(localStorage.getItem('compareListItems'));
                var lastseenVariationString = "";
                self.count = dataObjects.length;

                for (var i = 0; i < dataObjects.length; i++) {
                    if (i) {
                        lastseenVariationString += "&variationIds[]=" + dataObjects[i]
                    } else {
                        lastseenVariationString += "variationIds[]=" + dataObjects[i]
                    }
                }

                $.ajax({
                    url: '/rest/io/variations?' + lastseenVariationString + '&template=fubar',
                    method: "GET",
                    success: function(result) {
                        self.dataObjects = JSON.parse(result);
                        self.dataObjects = self.dataObjects.data.documents.reverse();
                        self.loaded = true;
                        self.ids = JSON.parse(localStorage.getItem('compareListItems'));
                        self.updateList();
                    }
                });
            } else {
                this.loaded = true;
            }
        },
        methods: {
            deleteAll() {
                var self = this;

                if (confirm('Sollen alle ' + self.count + ' Artikel vom Vergleich gelöscht werden?')) {
                    localStorage.setItem("compareListItems", "[]");

                    setTimeout(function () {
                        handleCountItemsCompare();

                        self.count = 0;

                        if (typeof(NotificationService) !== "undefined" && self.count == 0) {
                            NotificationService.success('<i class="fa fa-check"></i> Ihre Vergleichsliste wurde erfolgreich gelöscht. Sie können nun einen neuen Vergleich anlegen').closeAfter(6000);
                        }
                    }, 100);
                }
            },
            removeItem(e) {
                event.preventDefault();
                var self = this;

                const child = document.getElementById(e);
                const id = e.slice(1);
                child.remove();

                addOrRemoveToCompareList(id);

                setTimeout(function () {
                    const countHeader = JSON.parse(localStorage.getItem('compareListItems')).length;
                    self.count = countHeader;

                    document.getElementById('countItemsCompare').innerHTML = countHeader;

                    const xxx = document.getElementById('comHeader');
                    if (countHeader <= 0) {
                        xxx.classList.remove("yes");
                    } else {
                        xxx.classList.add("yes");
                    }

                    self.updateList();
                }, 300);
            },
            scrollLeft() {
                $('.scroller').animate( { scrollLeft: '+=250' }, 500);
            },
            scrollRight() {
                $('.scroller').animate( { scrollLeft: '-=250' }, 500);
            },
            updateList() {
                function setHeight( el, val ) {
                    if ( typeof val === "function" ) val = val();
                    if ( typeof val === "string" ) el.style.height = val;
                    else el.style.height = val + "px";
                }

                var equalheight = function ( container ) {
                    var currentTallest = 0,
                        currentRowStart = 0,
                        rowDivs = [],
                        currentDiv,
                        $el,
                        topPosition = 0;

                    Array.from( document.querySelectorAll( container ) ).forEach( ( el, i ) => {
                        el.style.height = "auto";
                        topPosition = el.offsetTop;
                        if ( currentRowStart != topPosition ) {
                            for ( currentDiv = 0; currentDiv < rowDivs.length; currentDiv++ ) {
                                setHeight( rowDivs[ currentDiv ], currentTallest );
                            }
                            rowDivs.length = 0;
                            currentRowStart = topPosition;
                            currentTallest = parseFloat( getComputedStyle( el, null ).height.replace( "px", "" ) );
                            rowDivs.push( el );
                        } else {
                            rowDivs.push( el );
                            currentTallest = ( currentTallest < parseFloat( getComputedStyle( el, null ).height.replace( "px", "" ) ) ) ? ( parseFloat( getComputedStyle( el, null ).height.replace( "px", "" ) ) ) : ( currentTallest );
                        }
                        for ( currentDiv = 0; currentDiv < rowDivs.length; currentDiv++ ) {
                            setHeight( rowDivs[ currentDiv ], currentTallest );
                        }
                    } );

                    const compareContainer = document.getElementById('compareContainer');
                    const scroller = document.getElementById('scroller').clientWidth;
                    const compareList = document.getElementById('compareList').clientWidth;

                    if (compareList > scroller) {
                        compareContainer.classList.add("show-nav");
                    } else {
                        compareContainer.classList.remove("show-nav");
                    }
                };

                setTimeout(function () {
                    equalheight('.compare .img');
                    equalheight('.compare .title');
                    equalheight('.compare .feedback');
                    equalheight('.compare .c2a-btns');
                    $('.compare .area + .area').remove();
                    $('.compare .uroom + .uroom').remove();
                    animate();
                }, 100);
            }
        }
    }
</script>
